import { merge } from 'maeng-utils/utils'
import { useMemo } from 'react'
import type { DialogActionProps } from '../components/Dialog'

const useDialogAction = ({
  confirmProps = {
    variant: 'contained',
    color: 'primary',
    children: '확인',
    size: 'medium',
  },
  cancelProps = {
    variant: 'outlined',
    children: '취소',
    size: 'medium',
  },
}: DialogActionProps) => {
  return useMemo(
    () => ({
      confirmProps: merge(
        {
          variant: 'contained',
          color: 'primary',
          children: '확인',
          size: 'medium',
        },
        confirmProps,
      ),
      cancelProps: merge(
        {
          variant: 'outlined',
          children: '취소',
          size: 'medium',
        },
        cancelProps,
      ),
    }),
    [cancelProps, confirmProps],
  )
}

export default useDialogAction
